import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { BrandCode } from '../models/curriculum';
import { CurriculumPricingEntity, CurriculumPricing } from '../models/curriculumPricing';

const getCurriculumCombos = (curriculum: CurriculumPricingEntity, allBrandCurriculum: CurriculumPricingEntity[]) => {
  return allBrandCurriculum.filter(
    c =>
      c.isCombo &&
      c.id !== curriculum.id &&
      c.license.findIndex(l => curriculum.license.map(l => l.itemNumber).includes(l.itemNumber)) > -1
  );
};

export const getCurriculumPricing: (brandCode?: BrandCode) => Promise<CurriculumPricing[]> = brandCode => {
  return cacheableRequest(`/v1/curriculumPricing?v=${window.config.CURRICULUM_PRICING_VERSION}`).then(
    (response: AxiosResponse<CurriculumPricing[]>) => {
      if (!brandCode) return response.data;
      return response.data.filter(c => c.brand.code.toLowerCase() === brandCode.toLowerCase());
    }
  );
};

export const getCurriculumPricingById: (
  brandCode: BrandCode,
  curriculumId: string
) => Promise<[CurriculumPricing, CurriculumPricingEntity[]]> = (brandCode, curriculumId) => {
  return getCurriculumPricing(brandCode)
    .then((curriculumPricingEntities: CurriculumPricing[]) => {
      if (curriculumPricingEntities.length === 0) {
        throw new Error(`Unable to find ${brandCode} curriculum pricing`);
      }
      return curriculumPricingEntities[0];
    })
    .then((curriculumEntity: CurriculumPricing) => {
      const curriculum = curriculumEntity.curriculum.find(c => c.id === curriculumId);

      if (!curriculum) throw new Error(`Unable to find ${brandCode} curriculum with ID of ${curriculumId}`);

      const combos = getCurriculumCombos(curriculum, curriculumEntity.curriculum);

      const filteredCurriculumEntity = {
        brand: curriculumEntity.brand,
        curriculum: [curriculum],
      } as CurriculumPricing;

      return [filteredCurriculumEntity, combos];
    });
};
